import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { ORDENESCOMPRAS_NUEVA, ORDENESCOMPRAS_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevaPage from './nueva'

export default function OrdenesCompraPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${ORDENESCOMPRAS_NUEVA}/:id`} component={NuevaPage} />
        <Route path={`/${ORDENESCOMPRAS_NUEVA}`} component={NuevaPage} />
        <Route path={`/${ORDENESCOMPRAS_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
